const SeparadorLogin = ({texto}) => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          marginTop: 40,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "var(--color-grey85)",
            height: 1,
            width: "78px",
          }}
        />
        <div
          style={{
            textAlign: "center",
            height: 1,
            width: "calc(100% - 156px)",
          }}
        >
          <p
            className="rb12m"
            style={{ transform: "translate(0px, -7px)" }}
          >
            {texto}
          </p>
        </div>
        <div
          style={{
            backgroundColor: "var(--color-grey85)",
            height: 1,
            width: "78px",
          }}
        />
      </div>
    );
  };
  
  export default SeparadorLogin;
  